export const getTransportistColumns = () => {
  return [
    {
      'Header': 'COMPAÑÍA',
      'accessor': 'courierName',
      'width': 4,
    },
    {
      'Header': 'CÉDULA',
      'accessor': 'driverRuc',
      'width': 2,
    },
    {
      'Header': 'NOMBRE',
      'accessor': 'driverName',
      'width': 4,
    },
    {
      'Header': 'PLACA',
      'accessor': 'licencePlate',
      'width': 1,
    },
    {
      'Header': 'TELEFONO',
      'accessor': 'courierPhone',
      'width': 1,
    },
  ];
};
